"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How do I secure an initial consultation?",
  answer: "We operate on a referral and application basis to ensure every project receives our full attention. You may submit an inquiry via our Book a Consultation page to begin the vetting process."
}, {
  question: "What defines the requirements for project acceptance?",
  answer: "We prioritize projects that align with our commitment to heritage and excellence. Each application is reviewed for creative potential, timeline feasibility, and brand synergy to ensure a standard of pedigree."
}, {
  question: "How is the Custom Website timeline managed?",
  answer: "Our process is meticulous and unhurried. We provide a Custom Website roadmap during the discovery phase, ensuring every milestone meets our rigorous standards of quality and enduring impact."
}, {
  question: "What defines the 'Pedigree' of your work?",
  answer: "Pedigree is the intersection of timeless design principles and modern innovation. It represents a lineage of craft that values quality over quantity and lasting legacy over fleeting trends."
}, {
  question: "How do you ensure privacy for high-profile clients?",
  answer: "Discretion is our hallmark. All engagements are protected by strict confidentiality agreements, and we maintain secure, private communication channels for all sensitive asset transfers and creative exchanges."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19366" id="frequently-asked-questions" className="relative w-full py-24 overflow-hidden bg-[#2D1B33] text-[#F5F5F0]">
      {}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-[#E6E6FA]/10 rounded-full blur-[120px] -translate-x-1/3 -translate-y-1/3 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#D4AF37]/5 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3 pointer-events-none" />

      <div ref={ref} className={cn("container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-12 tracking-tight text-[#F5F5F0]">
            Questions of Pedigree
          </h2>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E6E6FA]/20 px-2" data-index={i}>
                <AccordionTrigger className={cn("text-xl font-serif font-medium text-[#F5F5F0] hover:text-[#D4AF37] hover:no-underline py-6 text-left", "transition-all duration-[1200ms] ease-in-out", "[&[data-state=open]]:text-[#D4AF37]")}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base font-sans text-[#E6E6FA]/80 pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}